import React, { createRef, useEffect, useState } from "react";
import NavBarHeader from "../../NavBarHeader/NavBarHeader";
import ScrolltoTop from "../../ScrollTop/ScrollTop";
import TranslationFile from "../../15-Translation/locale/Translation_apps.json";
import Footer_contact_tab from "../../Footerpage/Footer_contact_tab";
import carousel1 from "../../../Assests/ink2.webp";
import { Button } from "primereact/button";
import "./SRUHomePage.css";
import { Helmet } from "react-helmet-async";
import sruimage1 from "../../../Assests/SruSliderImg1.png";
import sruimage2 from "../../../Assests/SruSliderImg2.png";
import sruimage3 from "../../../Assests/SruSliderImg3.png";
import sruimage4 from "../../../Assests/SruSliderImg4.png";
import sruimage5 from "../../../Assests/SruSliderImg5.png";
import DemoSlide from "../../DemoSlide/DemoSlide";
import OtherServices from "../../OtherServices/OtherServices";
import axios from "axios";
import { Carousel } from "primereact/carousel";

let userSelectedLanguage;

const SRUHomePage = () => {
  userSelectedLanguage = localStorage.getItem("selectedLanguage");
  const [sideBarStatus, setSideBarStatus] = useState(false);
  const sliderImage = [
    {
      image: sruimage1,
      alt: "Sample1"
    },
    {
      image: sruimage2,
      alt: "Sample2"
    },
    {
      image: sruimage3,
      alt: "Sample3"
    },
    {
      image: sruimage4,
      alt: "Sample4"
    },
    {
      image: sruimage5,
      alt: "Sample5"
    }
  ];
  const callback = (incomedeclaration2SRU, session, link, status) => {
    let sessionUUIDfromLS = localStorage.getItem("sessionUUID");
    if (status) {
      this.props.history.push(incomedeclaration2SRU + sessionUUIDfromLS + link);
    }
    scrollTo();
  };
  useEffect(() => {
    scrollTo();
  }, []);

  const scrollTo = () => {
    let currentPageUrl = window.location.href;
    let splitCurrentPageUrl = currentPageUrl.split("/");
    let IsAnnualReportPage = splitCurrentPageUrl.includes("annualreport");
    console.log("IsAnnualReportPage:", IsAnnualReportPage);
    let scrollToLs = localStorage.getItem("scrollTo");
    if (
      splitCurrentPageUrl[splitCurrentPageUrl.length - 1] == "#how-it-works" ||
      scrollToLs == "#how-it-works"
    ) {
      window.history.pushState(null, "", "/income-declaration-2/#how-it-works");
      window.scrollTo({
        top: document.getElementById("sru-how-it-works").offsetTop - 100,
        behavior: "smooth"
      });
    }

    if (
      splitCurrentPageUrl[splitCurrentPageUrl.length - 1] == "#prices" &&
      IsAnnualReportPage
    ) {
      window.history.pushState(null, "", "/annualreport/#prices");

      const pricesElement = document.getElementById("prices-div-home");
      if (pricesElement) {
        window.scrollTo({
          top: pricesElement.offsetTop - 100,
          behavior: "smooth"
        });
      }
    } else if (
      splitCurrentPageUrl[splitCurrentPageUrl.length - 1] == "#faq" &&
      IsAnnualReportPage
    ) {
      window.history.pushState(null, "", "/annualreport/#faq");
      const faqElement = document.getElementById("faq-div-home");
      if (faqElement) {
        window.scrollTo({
          top: faqElement.offsetTop - 100,
          behavior: "smooth"
        });
      }
    }
  };
  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: "1024px",
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: "768px",
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: "560px",
      numVisible: 1,
      numScroll: 1
    }
  ];
  const NavigateToInk2 = async () => {
    try {
      localStorage.setItem("sruNavigateTo", "companyInfo");
      localStorage.setItem("navigateToGUID", "");
      localStorage.setItem("navigatedCompanyName", "");
      localStorage.setItem(
        "sruPossibleAccessablePages",
        JSON.stringify(["My Dashboard"])
      );
      localStorage.setItem("appType", "Income Declaration");

      const response = await axios.get("/cms/generateUUID");

      const newReportGUID = response.data;

      console.log("UUID:", newReportGUID);

      window.location.href = `/income-declaration-2/${newReportGUID}/companyInfo`;
      window.target = "_blank";
    } catch (error) {
      console.error("Error generating UUID:", error);
    }
  };
  const imageTemplate = (item) => {
    return (
      <div className="SRUCarouselImageWrapper">
        <img src={item.image} alt={item.alt} className="SRUCarouselImage" />
      </div>
    );
  };
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {userSelectedLanguage == "sw"
            ? TranslationFile.FaviconAppText[userSelectedLanguage]
            : TranslationFile.FaviconAppText.en}
        </title>
      </Helmet>

      <NavBarHeader callBack={callback} />
      <div className="SRUHomePage">
        <div className="SRU-image-container">
          <img src={carousel1} alt="Sample" className="image" />
          <div className="image-text">
            <div className="SRU-home-banner-title">
              {TranslationFile.SrucarouselTitle[userSelectedLanguage]}
            </div>

            <div className="SRU-home-banner-description">
              {TranslationFile.SrucarouselParagraph1[userSelectedLanguage]}
            </div>

            <div className="SRU-home-banner-price">
              {TranslationFile.for[userSelectedLanguage]}
            </div>

            <div className="SRU-home-banner-button-div">
              <Button
                className="SRU-home-banner-button"
                onClick={NavigateToInk2}
              >
                {TranslationFile.SRUNavbarFree[userSelectedLanguage]}
              </Button>
            </div>
          </div>
        </div>
        <div className="sru-about-div-home" id="sru-how-it-works">
          <center>
            <div className="about-div-home-title" style={{ marginTop: "50px" }}>
              <br></br>
              <h4 className="demo-title-heading">
                {TranslationFile.SRUdemoTitle1[userSelectedLanguage]}
                <br></br>
                <br></br>
                {TranslationFile.demoTitle2[userSelectedLanguage]}
              </h4>
            </div>
            <Carousel
              value={sliderImage}
              itemTemplate={imageTemplate}
              numVisible={1}
              numScroll={1}
              responsiveOptions={responsiveOptions}
              circular
              autoplayInterval={3000}
              showNavigators={false}
              className="SRUCarousel"
              showIndicators
            />
          </center>
        </div>
        <div className="other-services-div">
          <OtherServices />
        </div>
      </div>
      <ScrolltoTop />
      <Footer_contact_tab
        sideBar={sideBarStatus}
        isCorpPortal={false}
        isHomePage={true}
      />
    </div>
  );
};

export default SRUHomePage;
